import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import styled from 'styled-components';
import { stripePromise } from '../stripe-promise';
import { EmptyHeader } from './shared-modal-components';
import { Dialog } from '@primer/react/experimental';

interface UpgradeStripeCheckoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  fetchClientSecret: () => Promise<string>;
}

export function UpgradeStripeCheckoutModal({ isOpen, onClose, fetchClientSecret }: UpgradeStripeCheckoutModalProps) {
  if (!isOpen) return null;

  if (!stripePromise) {
    return (
      <CheckoutDialog title="Complete upgrade payment" onClose={onClose} width="xlarge" renderHeader={EmptyHeader}>
        <CheckoutContainer>
          <CheckoutHeader>
            <h2>Payment unavailable</h2>
            <p>
              Payment processing is not configured. Please contact Upright support to complete your upgrade, or try
              again later.
            </p>
          </CheckoutHeader>
        </CheckoutContainer>
      </CheckoutDialog>
    );
  }

  const options = { fetchClientSecret };

  return (
    <CheckoutDialog title="Complete upgrade payment" onClose={onClose} width="xlarge" renderHeader={EmptyHeader}>
      <CheckoutContainer>
        <CheckoutHeader>
          <h2>Complete payment</h2>
          <p>This is a one-time payment that upgrades your assessment to Pro tier with 12-month access.</p>
        </CheckoutHeader>
        <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </CheckoutContainer>
    </CheckoutDialog>
  );
}

// Override Primer Dialog to remove default header bar and apply consistent border-radius.
const CheckoutDialog = styled(Dialog)`
  &[role='dialog'] {
    border-radius: var(--border-radius__xl);
  }
`;

const CheckoutContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: var(--space__xl);
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

const CheckoutHeader = styled.div`
  margin-bottom: var(--space__xl);
  text-align: center;

  h2 {
    font-size: var(--font-size__2xl);
    font-weight: var(--font-weight__medium);
    margin-bottom: var(--space__sm);
  }

  p {
    font-size: var(--font-size__sm);
    color: var(--color__gray-500);
  }
`;
